module.exports = __webpack_public_path__ + "static/item1-dfe7cef7ba2a95528796f765a87f72b7.jpg";